module.exports = __webpack_public_path__ + "static/media/face-3.93551208.jpg";